import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import Cookies from 'universal-cookie';
import axios from 'utils/axios';
import axiosAdmin from 'utils/axiosAdmin';
import URL from 'config/url';

const cookies = new Cookies();

const USER_DETAILS_KEY = 'xeni_user_details';

const saveUserDetailsToStorage = (userDetails) => {
  if (userDetails) {
    localStorage.setItem(USER_DETAILS_KEY, JSON.stringify(userDetails));
  } else {
    localStorage.removeItem(USER_DETAILS_KEY);
  }
};

const loadUserDetailsFromStorage = () => {
  try {
    const stored = localStorage.getItem(USER_DETAILS_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
};

export const userLogin = createAsyncThunk('USER/LOGIN', async (data, thunkAPI) => {
  const response = await axiosAdmin.post(URL.LOGIN, data, thunkAPI);
  return response.data;
});

export const getUserProfile = createAsyncThunk('USER/DETAILS', async (_, thunkAPI) => {
  const response = await axiosAdmin.get(URL.USER_DETAILS, thunkAPI);
  return response.data;
});

const storedUserDetails = loadUserDetailsFromStorage();
const authToken = cookies.get('x-access-token');

const initialState = {
  isLoading: false,
  userDetails: authToken ? storedUserDetails : null,
  authToken: authToken,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearUserDetails: (state) => {
      state.userDetails = null;
      state.authToken = null;
      saveUserDetailsToStorage(null);
    },
  },
  extraReducers: {
    [userLogin.pending]: (state) => {
      state.isLoading = true;
      state.authToken = null;
    },
    [userLogin.fulfilled]: (state, action) => {
      state.isLoading = false;
      const data = action.payload;
      state.authToken = data.token;
      const userDetails = {
        id: data.id,
        name: data.name,
        email: data.email,
        roleId: data.roleId,
        roleName: data.roleName,
      };
      state.userDetails = userDetails;
      saveUserDetailsToStorage(userDetails);
      cookies.set('x-access-token', data.token);
    },
    [userLogin.rejected]: (state, action) => {
      state.isLoading = false;
      state.authToken = null;
      state.userDetails = null;
      saveUserDetailsToStorage(null);
      toast.error(action?.payload?.message);
    },
    [getUserProfile.pending]: (state) => {
      state.isLoading = true;
    },
    [getUserProfile.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.userDetails = action.payload.data;
      saveUserDetailsToStorage(action.payload.data);
    },
    [getUserProfile.rejected]: (state, action) => {
      state.isLoading = false;
      state.userDetails = null;
      saveUserDetailsToStorage(null);
      toast.error(action?.payload?.message);
    },
  },
});

export const { clearUserDetails } = userSlice.actions;

export default userSlice.reducer;
